import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "not-found-container" }

import { useRouter } from 'vue-router'

export default /*@__PURE__*/_defineComponent({
  __name: 'EmptyView',
  setup(__props) {

const router = useRouter()

function goHome() {
  router.push('/')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "code" }, "404", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "title" }, "页面未找到", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "tip" }, "你访问的页面不存在或已被删除", -1)),
    _createElementVNode("a", {
      class: "back-link",
      onClick: _withModifiers(goHome, ["prevent"]),
      href: "#"
    }, "返回首页")
  ]))
}
}

})